// ============================================
// Creator State - Firebase & Cache (Zustand 기반)
// ============================================

import { useCreatorStore } from '../../../stores/creatorStore.js';

// ============================================
// Firestore 인스턴스
// ============================================

let creatorDbInstance = null;

export function getCreatorDb() {
  if (!creatorDbInstance) {
    creatorDbInstance = firebase.firestore();
  }
  return creatorDbInstance;
}

// ============================================
// 캐시 관리
// ============================================

export function getCache() {
  return useCreatorStore.getState().cache;
}

export function isCacheValid(cacheKey) {
  return useCreatorStore.getState().isCacheValid(cacheKey);
}

export function setCache(cacheKey, data) {
  useCreatorStore.getState().setCache(cacheKey, data);
}

export function invalidateCache(cacheKey) {
  useCreatorStore.getState().invalidateCache(cacheKey);
}
